var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "my-teams-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "team-filter-tabs mb-4"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      active: !_vm.showOwnTeams
    },
    on: {
      "click": function ($event) {
        return _vm.toggleTeamType(false);
      }
    }
  }, [_vm._v(" Joined Teams ")]), _c('button', {
    staticClass: "btn",
    class: {
      active: _vm.showOwnTeams
    },
    on: {
      "click": function ($event) {
        return _vm.toggleTeamType(true);
      }
    }
  }, [_vm._v(" My Teams ")])]), _c('TeamList', {
    attrs: {
      "teams": _vm.myTeams,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "team-detail-base-url": _vm.teamDetailBaseUrl,
      "is-my-teams": true
    },
    on: {
      "page-changed": _vm.handlePageChange
    }
  })], 1)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }